import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { AxiosError, AxiosResponse } from 'axios';

import { api } from '.';

export type GetThesisParamsType = {
	start_year?: string;
	end_year?: string;
	volume?: string;
	issue?: string;
	title?: string;
	author?: string;
	keyword?: string;
	abstract?: string;
	page?: number;
	row?: number;
};

export type ThesisItem = {
	thesis_pk: number | string;
	thesis_title: string;
	thesis_author: string;
	thesis_year: string | number;
	thesis_publish_date: string;
	thesis_volume: string | number;
	thesis_issue: string | number;
	thesis_keyword: string;
	thesis_abstract: string;
};

export type GetThesisResType = {
	thesis?: ThesisItem[];
	list?: ThesisItem[];
	items?: ThesisItem[];
	total?: number;
	total_count?: number;
	thesis_count?: number;
	totalCount?: number;
};

export const useGetThesisApi = (params: GetThesisParamsType) => {
	const url = '/front/getThesis';

	return useQuery<AxiosResponse, AxiosError, GetThesisResType>({
		queryKey: [url, params],
		queryFn: () => api.get(url, params),
		select: (res) => res.data.data,
		placeholderData: keepPreviousData,
	});
};

type GetThesisDetailParamsType = {
	thesis_pk: number | string;
};

export type ThesisDetail = ThesisItem & {
	file_path?: string;
	file_original_name?: string;
	html_url?: string;
	thesis_content?: string;
	content?: string;
	abstract?: string;
};

export type ThesisDetailFile = {
	file_pk?: number | string;
	file_path?: string;
	file_save_name?: string;
	file_original_name?: string;
	file_extension?: string;
};

export type GetThesisDetailResType = {
	thesis?: ThesisDetail;
	detail?: ThesisDetail;
	item?: ThesisDetail;
	file?: ThesisDetailFile[];
} & Partial<ThesisDetail>;

export const useGetThesisDetailApi = (params: GetThesisDetailParamsType, enabled: boolean) => {
	const url = '/front/getThesisDetail';

	return useQuery<AxiosResponse, AxiosError, GetThesisDetailResType>({
		queryKey: [url, params],
		queryFn: () => api.get(url, params),
		select: (res) => res.data.data,
		enabled,
	});
};
